import React from 'react';
import { SvgIcon } from '@ui-elements';
import styles from './index.module.scss';

interface PrivacyToggleProps {
  isOpen?: boolean;
  onClick: () => void;
}

export const PrivacyToggle: React.FC<PrivacyToggleProps> = ({
  isOpen,
  onClick,
}) => (
  <button type="button" className={styles.PrivacyToggle} onClick={onClick}>
    <span>View Privacy Collection Statement</span>
    <SvgIcon type={isOpen ? 'chevronUp' : 'chevronDown'} />
  </button>
);
